import {
  AfterViewInit,
  Component,
  forwardRef,
  inject,
  Injector,
  input,
} from '@angular/core';
import {
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
  Validators,
} from '@angular/forms';
import { FormField } from '@shared/classes';

import { FieldErrorsComponent } from '../field-errors/field-errors.component';

@Component({
  selector: 'b2c-text-area',
  styleUrl: './text-area.component.scss',
  templateUrl: './text-area.component.html',
  imports: [FormsModule, FieldErrorsComponent],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaComponent),
    },
  ],
})
export class TextAreaComponent extends FormField implements AfterViewInit {
  label = input<string>('');
  type = input<string>('text');
  minlength = input<string>('0');
  ariaLabel = input<string>('');
  placeholder = input<string>('');
  id = input<number>(Math.random());
  maxlength = input<string>('52100');
  required = input<boolean>(false);
  serverErrorMessage = input<string>('');
  errorMessages = input<Record<string, string>>({});

  private readonly injector: Injector = inject(Injector);

  protected get isRequired(): boolean {
    return this.required() || !!this.control?.hasValidator(Validators.required);
  }

  protected get ariaDescribedBy(): string | null {
    return this.control?.invalid && this.control?.dirty
      ? `${this.id()}-errors`
      : null;
  }

  ngAfterViewInit(): void {
    const ngControl: NgControl | null = this.injector.get(NgControl, null);
    if (ngControl) {
      this.control = ngControl.control as FormControl;
    }
  }
}
